module.exports = {
  home: 'Home',
  favorites: 'Favorites',
  credentials: 'Credentials',
  credentialCreate: 'Credential',
  credentialEdit: 'Credential',
  credentialCopy: 'Credential',
  credentialRestore: 'Credential',
  triggers: 'Triggers',
  workflow: 'Workflow',
  cron: 'Cron',
  cronCreate: 'Cron Trigger',
  cronEdit: 'Cron Trigger',
  cronCopy: 'Cron Trigger',
  cronRestore: 'Cron Trigger',
  rest: 'REST',
  restCreate: 'REST Trigger',
  restEdit: 'REST Trigger',
  restCopy: 'REST Trigger',
  restRestore: 'REST Trigger',
  uiTrigger: 'UI',
  uiTriggerCreate: 'UI Trigger',
  uiTriggerEdit: 'UI Trigger',
  uiTriggerCopy: 'UI Trigger',
  uiTriggerRestore: 'UI Trigger',
  mcp: 'MCP',
  mcpCreate: 'MCP Trigger',
  mcpEdit: 'MCP Trigger',
  mcpCopy: 'MCP Trigger',
  mcpRestore: 'MCP Trigger',
  logs: 'Logs',
  logsSteps: 'Steps',
  logsEvents: 'Events',
  pages: 'Pages',
  processes: 'Processes',
  processCreate: 'Process',
  processEdit: 'Process',
  processCopy: 'Process',
  processRestore: 'Process',
  access: 'Access',
  users: 'Users',
  userCreate: 'User',
  userEdit: 'User',
  roles: 'Roles',
  roleCreate: 'Role',
  roleEdit: 'Role',
  roleCopy: 'Role',
  templates: 'Templates',
  templateCreate: 'Template',
  templateEdit: 'Template',
  templateCopy: 'Template',
  templateRestore: 'Template',
  translations: 'Translations',
  translationCreate: 'Translation',
  translationEdit: 'Translation',
  translationCopy: 'Translation',
  translationRestore: 'Translation',
  settings: 'Settings',
  frontend: 'Frontend',
  'instance-processing': 'Instance Processing',
  // NOTE: Keep in sync with 'instanceAdmin' key (line ~112) - both display the same page title
  // This key is used for breadcrumb/page title (dynamic lookup by route name)
  'instance-settings': 'Instance Admin',
  plugin: 'Plugin',
  settingCreate: 'Setting',
  settingEdit: 'Setting',
  settingRestore: 'Setting',
  globalSettings: 'Global Settings',
  globalSettingsCreate: 'Global Setting',
  globalSettingsEdit: 'Global Setting',
  instance: 'Instance',
  smtp: 'Smtp',
  modules: 'Modules',
  profile: 'Profile',
  validations: 'Validations',
  validationCreate: 'Validation',
  validationEdit: 'Validation',
  validationCopy: 'Validation',
  validationRestore: 'Validation',
  staticResources: 'Static Resources',
  'static-resources': 'Static Resources',
  staticResourcesCreate: 'Static Resource',
  staticResourcesEdit: 'Static Resource',
  assets: 'Assets',
  process: 'Process',
  local: 'Local',
  hub: 'Hub',
  moduleCreate: 'Module',
  moduleEdit: 'Module',
  moduleRestore: 'Module',
  moduleImport: 'Import Module',
  hubEdit: 'Hub Module',
  gdpr: 'GDPR',
  gdprAiAgents: 'AI Agents',
  gdprApplications: 'Applications',
  gdprCronTrigger: 'Cron Trigger',
  gdprRestTrigger: 'Rest Trigger',
  gdprScreens: 'Screens',
  gdprFlows: 'Flows',
  gdprTriggerUis: 'UI Trigger',
  gdprModules: 'Modules',
  gdprProcessCredentials: 'Credentials',
  gdprProcesses: 'Processes',
  plugins: 'Plugins',
  pluginCreate: 'Plugin',
  pluginEdit: 'Plugin',
  pluginCopy: 'Plugin',
  pluginRestore: 'Plugin',
  instances: 'Instances',
  messaging: 'Messaging',
  messagingCreate: 'Messaging Trigger',
  messagingEdit: 'Messaging Trigger',
  messagingCopy: 'Messaging Trigger',
  messagingRestore: 'Messaging Trigger',
  instanceProcessing: 'Instance Processing',
  // NOTE: Keep in sync with 'instance-settings' key (line ~63) - both display the same page title
  // This key is used for navigation menu (explicit reference in Layout.vue)
  instanceAdmin: 'Instance Admin',
  telemetries: 'Telemetries',
  'logs-telemetry': 'Telemetry',
  'logs-steps': 'Steps',
  'logs-events': 'Events',
  'logs-instances': 'Instances',
  logInstanceStats: 'Instance Stats',
  'logs-internal-jobs': 'Internal Jobs',
  date: 'Date',
  links: 'Links',
  history: 'History',
  historyEdit: 'History Entry',
  massChanges: 'Mass Changes',
  'mass-changes': 'Mass Changes',
  admin: 'Admin',
  entities: 'Entities',
  entityCreate: 'Entity',
  entityEdit: 'Entity',
  entityCopy: 'Entity',
  entityRestore: 'Entity',
  entityGenerate: 'Generate Entity',
  libraries: 'Libraries',
  libraryCreate: 'Library',
  libraryEdit: 'Library',
  libraryCopy: 'Library',
  libraryRestore: 'Library',
  gdprLibraries: 'Libraries',
  gdprMcpTrigger: 'MCP Trigger',
  gdprMessagingTrigger: 'Messaging Trigger',
  storage: 'Storage',
  storageCreate: 'Storage',
  storageEdit: 'Storage',
  eventHandler: 'Event Handlers',
  eventHandlerCreate: 'Event Handler',
  eventHandlerEdit: 'Event Handler',
  eventHandlerCopy: 'Event Handler',
  eventHandlerRestore: 'Event Handler',
  flow: 'Flow',
  flows: 'Flows',
  flowCreate: 'Flow',
  flowEdit: 'Flow',
  flowCopy: 'Flow',
  flowRestore: 'Flow',
  gdprEntities: 'Entities',
  gdprEventHandlerTrigger: 'Event Handler Trigger',
  global: 'Global',
  browseData: 'Browse Data',
  cache: 'Cache',
  tags: 'Tags',
  tagCreate: 'Tag',
  tagEdit: 'Tag',
  tagCopy: 'Tag',
  importHistory: 'Import History',
  importHistoryEdit: 'Import History Entry',
  aiAgents: 'AI Agents',
  'ai-agents': 'AI Agents',
  aiAgentCreate: 'AI Agent',
  aiAgentEdit: 'AI Agent',
  aiAgentCopy: 'AI Agent',
  aiAgentRestore: 'AI Agent',
  applications: 'Applications',
  applicationCreate: 'Application',
  applicationEdit: 'Application',
  applicationCopy: 'Application',
  applicationRestore: 'Application',
  screen: 'Screens',
  screenCreate: 'Screen',
  screenEdit: 'Screen',
  screenCopy: 'Screen',
  screenRestore: 'Screen',
  tenants: 'Tenants',
  tenantCreate: 'Tenant',
  tenantEdit: 'Tenant',
  tenantCopy: 'Tenant',
  whatsapp: 'WhatsApp',
  whatsappCreate: 'WhatsApp Trigger',
  whatsappEdit: 'WhatsApp Trigger',
  whatsappCopy: 'WhatsApp Trigger',
  whatsappRestore: 'WhatsApp Trigger',
  gdprWhatsappTrigger: 'WhatsApp Trigger',
  login: 'Login'
}
